<template>
    <v-layout
        row
        wrap
        :style="setVirtualStyle"
        mb-6
        pa-2>
        <v-flex xs12>
            <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="mb-4 font-weight-bold"
            >
                {{ $t('form.appointmentOnReacts') }}
                <a :href="getReactsUrl" target="_blank" style="color: #ffffff;">
                    Reacts
                </a>{{ $t('form.appointmentOnReacts2') }}
            </v-alert>
        </v-flex>
        <v-flex xs12>
            <v-select
                v-model="hasVirtualAccountMeta"
                :items="virtualAccountSelectItems"
                :label="`* ${$t(`form.virtualAccountSelect.label`)}`"
                item-value="value"
                :name="metadata.name"
                :item-text="(i) => $t(`form.virtualAccountSelect.items.${i.value}`)"
                item-key="key"
                :color="$vuetify.theme.primary"
                :rules="[
                    v => v !== null || $t('base.errors.requiredField')
                ]"
            />
        </v-flex>
        <v-flex xs12>
            <v-layout v-if="hasVirtualAccountMeta" row wrap>
                <v-flex xs12 sm6 pr-1>
                    <v-text-field
                        :value="virtualEmail"
                        type="email"
                        :outlined="outlined"
                        :append-icon="appendIcon"
                        class="body-2"
                        :color="$vuetify.theme.primary"
                        :background-color="$vuetify.theme.primary"
                        :name="metadata.name"
                        :placeholder="$t('appt.placeholder.email')"
                        :aria-label="formattedAriaLabel(
                            metadata[`description${this.upperLocale}`],
                            required
                        )"
                        :label="formattedLabel(
                            metadata[`description${this.upperLocale}`],
                            required
                        )"
                        :data-testid="metadata.name"
                        :maxlength="maxLength"
                        counter
                        :rules="[
                            !required || requiredField(),
                            !hasVirtualAccountMeta || requiredField(),
                            v => !v || getFormRule('email')(v)
                        ]"
                        :data-meta-id="metadata.id"
                        @input="debouncedInput"
                    />
                </v-flex>
                <v-flex xs12 sm6 pl-1>
                    <v-text-field
                        v-model="virtualAccountEmailMetaConfirm"
                        type="email"
                        outlined
                        :color="$vuetify.theme.primary"
                        :background-color="$vuetify.theme.primary"
                        append-icon="fas fa-envelope"
                        :aria-label="formattedAriaLabel(
                            metadata[`description${this.upperLocale}`],
                            required
                        )"
                        :label="formattedLabel(
                            $t('form.confirmEmail'),
                            required
                        )"
                        :placeholder="$t('appt.placeholder.confirmEmail')"
                        validate-on-blur
                        :rules="[
                            v => !confirmReactsEmailCheck() ? $t('appt.errors.emailNoMatch') : true ]"
                    />
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-if="hasVirtualAccountMeta === false" xs12 class="text--warning mb-4">
            {{ $t('form.reactsRegisterMailInfo') }}
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { MetadataEnum } from '@/enums';
import { debounce } from 'lodash';

export default {
    name: 'virtual-account',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data: () => ({
        debouncedInput: undefined,
        hasVirtualAccountMeta: null,
        virtualAccountEmailMetaConfirm: '',
        virtualAccountSelectItems: [
            { id: 1, value: false },
            { id: 2, value: true },
        ],
    }),
    created() {
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    watch: {
        hasVirtualAccountMeta(val) {
            // If no virtual account, set previous email as virtual account email
            const metadata = this.getCopySelectedServiceMetadataValuesOverrideApplied;
            if (!val && metadata[MetadataEnum.EMAIL].value) {
                const metadata = this.getCopySelectedServiceMetadataValuesOverrideApplied;
                this.emitValue(metadata[MetadataEnum.EMAIL].value);
            }
        },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getCopySelectedServiceMetadataValuesOverrideApplied: 'services/getCopySelectedServiceMetadataValuesOverrideApplied',
        }),
        appendIcon() {
            return this.withIcon ? 'fas fa-envelope' : '';
        },
        getReactsUrl() {
            return this.$i18n.locale === 'en' ? 'https://reacts.com' : 'https://reacts.com/fr';
        },

        setVirtualStyle() {
            return 'border: 2px solid ' + this.$vuetify.theme.themes.light.primary + ';';
        },

        virtualEmail: {
            get: function() { return this.value; },
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
        /**
         * @description Validate email and confirm email
         * @returns {boolean}
         */
        confirmReactsEmailCheck() {
            return !this.value ||
                this.value === this.virtualAccountEmailMetaConfirm;
        },
    },
};
</script>
